import React, { useState, useMemo } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Box from 'ui-box';
import { Row, Typography, Button, Divider, Space } from 'antd';
import HeaderBack from '../../../components/mobile/HeaderBack';
import InputField from '../../../components/mobile/form-helpers/InputField';
import { FormInputPassword } from '../../../components/mobile/form-helpers/FormField';
import { ReactComponent as GoogleSvg } from '../../../assets/icons/google-colour.svg';
import { ReactComponent as FacebookSvg } from '../../../assets/icons/facebook.svg';
import { ReactComponent as GoogleLargeSvg } from '../../../assets/icons/user-account/google.svg';

const { Title } = Typography;

const styles = {
  divider: {
    fontSize: 14,
    fontWeight: 28,
    color: '#999999',
    margin: 0
  },
  rowButton: {
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  textLabelInfo: {
    fontWeight: "500",
    fontSize: "12px",
    lineHeight: "24px",
    textAlign: "right",
    color: "#15A9E1",
    margin: 0
  },
  rowLabel: {
    marginBottom: 8,
    padding: 0
  },
  signGoogle: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    alignItems: "center",
    border: "1px solid rgba(64, 64, 71, 0.22)",
    boxSizing: "border-box",
    borderRadius: "2px",
    padding: "18px 51px"
  },
  currentLogin: {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "14px",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    color: "#8C8C8C",
    margin: 0
  },
  emailGoogle: {
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    color: "#404047",
    margin: 0
  },
  label: {
    fontWeight: "300",
    fontSize: "14px",
    lineHeight: "28px",
    display: "flex",
    alignItems: "center",
    color: "#262626"
  }
}

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
}

function MobileAccountCredentialScreen() {
  const { t } = useTranslation(['user-account', 'common', 'welcome']);
  const [isLoginGoogle, setIsLoginGoogle] = useState(false);
  const history = useHistory();

  const FormSchema = useMemo(
    () =>
      Yup.object().shape({
        username: Yup.string().required(t('common:form.error.required')),
        password: Yup.string().required(t('common:form.error.required')),
      }),
    [t]
  );

  const initialValues = {
    username: '',
    password: ''
  };

  const onBack = () => {
    history.push('/user-account')
  }

  const confirmChange = () => {

  }

  const onConfirm = () => {

  }

  const onLoginWithEmail = () => {
    setIsLoginGoogle(false)
    history.push('/user-account/account-credential/login-with-email')
  }

  const onLoginWithGoogle = () => {
    setIsLoginGoogle(true)
  }

  const onLoginWithFacebook = () => {

  }

  const onSignOut = () => {

  }

  const renderFormLogin = () => {
    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={FormSchema}
        onSubmit={async (values) => {
          const dataForm = { ...values };
          console.log(dataForm)
        }}
      >
        {({ isSubmitting, setFieldValue }) => {
          return (
            <Form style={{ width: '100%' }}>
              <fieldset disabled={isSubmitting}>
                <Row justify="space-between" style={styles.rowLabel}>
                  <Title style={styles.label}>{t('common:form.label.emailAddress')}</Title>
                  <p style={styles.textLabelInfo}>{t('user-account:accountCredential.changeEmailAddress')}</p>
                </Row>
                <InputField
                  type="text"
                  name="username"
                  placeholder={t('common:form.placeholder.emailAddress')}
                />
                <Row justify="space-between" style={styles.rowLabel}>
                  <Title style={styles.label}>{t('common:form.label.password')}</Title>
                  <p style={styles.textLabelInfo}>{t('user-account:accountCredential.changePassword')}</p>
                </Row>
                <FormInputPassword
                  type="password"
                  name="password"
                  style={{ width: '100%', padding: '3%' }}
                  formItemLayout={formItemLayout}
                  onChange={(e) => setFieldValue('birth', e)}
                  placeholder={t('common:form.placeholder.password')}
                />
              </fieldset>
            </Form>
          );
        }}
      </Formik>
    )
  }

  const renderGoogleLogin = () => {
    return (
      <Space direction="vertical" style={{ width: '100%' }}>
        <Box style={styles.signGoogle}>
          <GoogleLargeSvg />
          <Row justify="start" style={{ padding: 0, marginLeft: 20}}>
            <p style={styles.currentLogin}>{t('user-account:accountCredential.signAs')}</p>
            <Title level={4} style={styles.emailGoogle}>
              sampleuser@gmail.com
            </Title>
          </Row>
        </Box>
        <Button
          htmlType="button"
          type="primary"
          size="large"
          onClick={onSignOut}
          block
          ghost
        >
          {t('common:button.signOut')}
        </Button>
      </Space>
    )
  }

  return (
    <>
      <HeaderBack
        onBack={onBack}
        text={t('user-account:accountCredential.previousPage')}
        title={t('user-account:accountCredential.title')}
        subtitle={t('user-account:accountCredential.subtitle')}
      />
      <Row style={{ padding: 0}}>
        {isLoginGoogle ? renderGoogleLogin() : renderFormLogin()}
      </Row>
      <Box marginTop={20}>
        <Divider plain><p style={styles.divider}>{t('user-account:accountCredential.alternateLogin')}</p></Divider>
      </Box>
      <Box textAlign="center">
        <Row gutter={[0, 24]}>
          <Space direction="vertical" style={{ width: '100%' }}>
            {
              isLoginGoogle && (
                <Button
                  htmlType="button"
                  type="primary"
                  size="large"
                  onClick={onLoginWithEmail}
                  block
                >
                  {t('welcome:signIn.loginWithEmail')}
                </Button>
              )
            }
            {
              !isLoginGoogle && (
                <Button
                  htmlType="button"
                  type="primary"
                  size="large"
                  onClick={onLoginWithGoogle}
                  block
                  ghost
                >
                  <p style={styles.rowButton}>
                    <GoogleSvg style={{ marginRight: 5 }}/>{t('welcome:signIn.loginWithGoogle')}
                  </p>
                </Button>
              )
            }
            <Button
              htmlType="button"
              type="primary"
              size="large"
              onClick={onLoginWithFacebook}
              block
              ghost
              style={{alignItems: 'center'}}
            >
              <p style={styles.rowButton}>
                <FacebookSvg style={{ marginRight: 5 }}/>{t('welcome:signIn.loginWithFacebook')}
              </p>
            </Button>
          </Space>
        </Row>
      </Box>
      <Button
        htmlType="button"
        type="primary"
        size="large"
        onClick={confirmChange}
        block
        style={{alignItems: 'center'}}
      >
        {t('common:button.confirmSaveChange')}
      </Button>
    </>
  );
}

export default MobileAccountCredentialScreen;
